import { z } from 'zod';

// ---------------------------------------------------------------------------
// Inlined from trusstor_dashboard/shared/interfaces/RoleType.enum.ts
// ---------------------------------------------------------------------------

export enum RoleType {
	TRUSSTOR_ADMIN = 'TRUSSTOR_ADMIN',
	PROJECT_ADMIN = 'PROJECT_ADMIN',
	MANAGER = 'MANAGER',
	EXECUTIVE = 'EXECUTIVE',
	VIEWER = 'VIEWER',
}

// ---------------------------------------------------------------------------
// UserPermissions  (from trusstor_dashboard/shared/interfaces/IUserPermissions.ts)
// ---------------------------------------------------------------------------

// Typed schema mirrors Trusstor's userPermissionsSchema exactly.
// Tighten or expand once Trusstor's IUserPermissions shape is confirmed stable.
export const trusstorUserPermissionsSchema = z
	.object({
		roleType: z.enum(RoleType),
		permittedProfessionsIds: z.array(z.string()).optional(),
	})
	.passthrough();

export type ITrusstorUserPermissions = z.infer<typeof trusstorUserPermissionsSchema>;
